/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
/* eslint-disable react/static-property-placement */
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Dropdown } from 'semantic-ui-react';

import FieldLayout from '../FieldLayout/FieldLayout';

class DropdownField extends PureComponent {
  static propTypes = {
    field: PropTypes.shape({
      name: PropTypes.string,
    }).isRequired,
    form: PropTypes.shape({
      setFieldValue: PropTypes.func,
      setFieldTouched: PropTypes.func,
      touched: PropTypes.shape({}),
      errors: PropTypes.shape({}),
    }).isRequired,
    placeholder: PropTypes.string,
    label: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({})),
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    search: PropTypes.bool,
    loading: PropTypes.bool,
    clearable: PropTypes.bool,
    errorInline: PropTypes.bool,
    onSearchChange: PropTypes.func,
    onFocus: PropTypes.func,
    header: PropTypes.element,
    minCharacters: PropTypes.number,
    className: PropTypes.string,
  };

  static defaultProps = {
    placeholder: '',
    label: '',
    options: [{}],
    onChange: () => true,
    onSearchChange: () => true,
    onFocus: () => true,
    disabled: false,
    search: false,
    loading: false,
    clearable: false,
    errorInline: false,
    header: null,
    minCharacters: 0,
    className: '',
  };

  handleChange = (event, { value }) => {
    const {
      field: { name },
      form,
      onChange,
    } = this.props;
    form.setFieldValue(name, value);
    onChange(name, value, form);
  };

  render() {
    const {
      placeholder,
      label,
      field: { value, name },
      options,
      disabled,
      search,
      onSearchChange,
      loading,
      onFocus,
      header,
      clearable,
      errorInline,
      minCharacters,
      className,
    } = this.props;

    const val = value === -1 ? undefined : value;
    return (
      <FieldLayout name={name} label={label} errorInline={errorInline}>
        <Dropdown
          placeholder={placeholder}
          fluid
          selection
          options={options}
          value={val}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          disabled={disabled}
          search={search}
          onSearchChange={onSearchChange}
          loading={loading}
          onFocus={onFocus}
          header={header}
          clearable={clearable}
          minCharacters={minCharacters}
          className={className}
          selectOnBlur={false}
        />
      </FieldLayout>
    );
  }
}

export default DropdownField;
